const redirectToCompanyPage = () => {
  window.location.href = 'https://britenet.com.pl/';
};

export default redirectToCompanyPage;
